import { io } from 'socket.io-client';
import { api_urls } from '../../api-urls';
import * as ChatActions from '../../../redux/actions/chatAction';
import * as CommonActions from '../../../redux/actions/commonAction';
import * as ConsultationActions from '../../../redux/actions/consultationAction';
import * as AstrologerActions from '../../../redux/actions/astrologerAction';
import { toaster } from '../toast-service';
import Swal from 'sweetalert2';

const SOCKET_URL = api_urls;

class SocketService {
    constructor() {
        this.socket = null;
    };

    static initializeSocket = async (dispatch, navigate, userId, user_type) => {
        if (this.socket) {
            console.log('Socket is already initialized !!!');
            return;
        }

        try {
            this.socket = io(SOCKET_URL, {
                transports: ['websocket'],
                query: { userId, user_type },
                reconnection: true,
                reconnectionAttempts: Infinity,
                reconnectionDelay: 1000,
                reconnectionDelayMax: 5000,
                timeout: 20000,
            });

            //* Listen for connection
            this.socket.on('connect', () => {
                console.log(`Connected to server with socket ID: ${this.socket.id} and user ID: ${this.socket?._opts?.query?.userId}`);
                dispatch(CommonActions?.setSocketConnectionStatus(true));
            });

            //* Listen for disconnection
            this.socket.on('disconnect', (reason) => {
                console.log('Disconnected from server:', reason);
                dispatch(CommonActions?.setSocketConnectionStatus(false));
                if (reason === 'io server disconnect') {
                    this.socket.connect();
                }
            });

            //! Consultation
            this.socket.on('notification', data => {
                console.log("Notification Event Data ::: ", data);
                Swal.fire({ icon: 'info', text: data, showConfirmButton: false });
                if (data == 'Please wait for astrologer joined') navigate(-1, { replace: true })
            });

            this.socket.on('update-consultation-timer', data => {
                // console.log("Update Consultation Timer Event Data ::: ", data);
                dispatch(ConsultationActions.setConsultationTimerCountdown(data));
            });

            this.socket.on('close-consultation-timer', async () => {
                console.log("Close Consultation Timer Event Run !!!");
                dispatch(ConsultationActions.closeConsultationSession({ consultationId: localStorage?.getItem('consultationId'), onComplete: () => navigate('/', { replace: true }) }));
            });

            //! Live
            this.socket.on('liveAstrologersList', data => {
                console.log("Live Astrologers List Data ::: ", data);
                dispatch(AstrologerActions.setLiveAstrologer(data))
            });

            //! Old
            this.socket.on('updateChatTimer', data => {
                console.log("Timer Data ::: ", data);
                dispatch(ChatActions.setChatTimerCountdown(data));
            });

            this.socket.on('remove-notification-listen', (data) => {
                console.log("Remove-Notification-Listen Event Run!!!");
                localStorage?.removeItem('rejectChatByAstrologerTimer');
                toaster.info({ text: 'You have missed the chat request!' });
                dispatch(ChatActions?.rejectChatByAstrologer({ rejected: false, timer: 60 }));
                navigate(`/`);

                // const payload = {
                //     data: { status: "Missed", requestedData: { chatId: data?.roomID } },
                //     onMissed: () => {
                //         navigate(`/`)
                //     },
                // };

                // dispatch(ChatActions.chatRequestAcceptRejectByAstrologer(payload))
            });

            this.socket.on('timerStopped', async () => {
                console.log("Timer Stopped Event Run !!!");
                dispatch(ChatActions.closeChatMessage({ chatId: localStorage?.getItem('chatId'), onComplete: () => navigate('/', { replace: true }) }));
                // await localStorage.removeItem('chatId');
            });

            this.socket.on('chatEnded', () => {
                console.log("Chat Ended Event Run !!!");
            });

            this.socket.on('walletAlert', () => {
                console.log("Wallet Alert Event Run !!!");
                //* dispatch(ChatActions.setChatWalletAlert(data))
            })

            this.socket.on('error', data => {
                console.log('Socket Error', data);
            });
        } catch (error) {
            console.log('Socket initialization failed !!!', error);
        }
    };

    static emit(event, data = {}) {
        console.log("Inside Socket")
        if (this.socket && this.socket.connected) {
            console.log("Socket Connected")
            console.log('Emitting event:', event, 'with data:', data);
            this.socket.emit(event, data);
        } else {
            console.log('Socket is not connected. Cannot emit event:', event);
        }
    }

    // static removeListener(listenerName) {
    //     this.socket.removeAllListeners(listenerName);
    // }
    static removeListener(event) {
        if (this.socket) {
            this.socket.removeListener(event);
            console.log(`Stopped listening to ${event} event.`);
        }
    };

    static disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            console.log('Socket disconnected.');
        }
    };
}

export default SocketService;